import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CREATE_PICKING_QUARENTINE_" }
);

export interface CreatePickingQuarentineState extends IState {}

const INITIAL_STATE: CreatePickingQuarentineState = {
  loading: false,
  error: null,
};

const request = (state: CreatePickingQuarentineState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CreatePickingQuarentineState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: CreatePickingQuarentineState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const createPickingQuarentine = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CreatePickingQuarentineTypes = Types;
export const CreatePickingQuarentineActions = Creators;
